import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,

} from "@mui/material";
import { Tooltip } from "antd";
import { makeStyles } from "@mui/styles";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import SearchIcon from "@mui/icons-material/Search";
import Layout from "../../components/Wrappers/Layout";
import {
	Alert, Row,
	Col,
	Card
} from "reactstrap";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import { AiOutlineSearch } from "react-icons/ai";
import { AiOutlineUserAdd } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { FormControl } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns"
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
// import Autocomplete, {
// 	createFilterOptions
// } from "@mui/material/lab/Autocomplete";
import Autocomplete from "@mui/lab/Autocomplete";
import { createFilterOptions } from "@mui/material";

import {
	resetGetWayTransactionList,
	getWayTransactionList
} from "../../redux/actions/getWayTransactionListAction";
import {
	resetViewTransactionDetails,
	getViewTransactionDetails
} from "../../redux/actions/viewTransactionDetailsAction";
import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import BackButton from "../../components/BackButton/BackButton";
import Util from "../../validation";
import SOLogout from "../../components/Logout/SOLogout";
import { getUserNameContactSuggestionList } from "../../redux/actions/partnerGetUserNameContactSuggestionAction"
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
// import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentIcon from '@mui/icons-material/Assignment';
import IconButton from "@mui/material/IconButton";
import { resetGetInquiry, getInquirys } from "../../redux/actions/getInquiryAction"
import FlipCameraAndroidIcon from '@mui/icons-material/FlipCameraAndroid';
// import { getCode } from "../../utils/countries";
import { getCodes } from "../../utils/countriesDropdown"
import EditIcon from "@mui/icons-material/Edit";
import FindInPageIcon from '@mui/icons-material/FindInPage';
import { partnerUpdateGatewayTransactions, resetUpdateGatewayTransaction } from "../../redux/actions/partnerUpdateGatewayTransactionAction"
import getSymbolFromCurrency from "currency-symbol-map";
import { partnerBulkUpdateStatus, resetBulkUpdateStatusPartner } from "../../redux/actions/bulkUpdateStatusPartnerAction"


const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const Transaction = () => {
	const [isLoading, setIsLoading] = useState(false);
	const dispatch = useDispatch();
	const [btnAction, setbBtnAction] = useState("");

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;

	var date = new Date();
	const [selectedDate, setSelectedDate] = useState(
		new Date(date.getFullYear(), date.getMonth(), 1)
	);
	const navigate = useHistory();
	const [getTransactionTypeListResArray, setGetTransactionTypeListResArray] =
		useState("");
	const [selectedToDate, setSelectedToDate] = useState(new Date());
	const [customerId, setCustomerId] = useState("");
	const [transactionId, setTransactionId] = useState("");
	const [transactionType, setTransactionType] = useState("");
	const [transStatus, setTransStatus] = useState("");
	// console.log(transStatus, "transStatus")
	const [toCustContact, setToCustContact] = useState("");
	const [toCustName, setToCustName] = useState("")
	const [currency, setCurrency] = useState("");
	const [isFee, setIsFee] = useState("");
	// const [rowsPerPage, setRowsPerPage] = useState(5);
	// const [page, setPage] = useState(0);
	const [customerOrMobName, setCustomerOrMobName] = useState("");

	const [isMaskedEmail, setIsMaskedEmail] = useState(true);
	const [inquiryOpenModal, setInquiryOpenModal] = useState(false);
	const [openUpdateModal, setOpenUpdateModal] = React.useState(false);
	const [notificationRefundOpen, setNotificationRefundOpen] =
		React.useState(false);
	const [bulkStatusOpen, setBulkStatusOpen] =
		React.useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [pageNo, setPageNo] = useState(0)
	// const [inquiryStatus, setInquiryStatus] =
	// useState(false);
	// const maskEmail = (isMaskedEmail = '') => {
	// 	const [name, domain] = email.split('@');
	// 	const { length: len } = name;
	// 	const maskedName = name[0] + '...' + name[len - 1];
	// 	const maskedEmail = maskedName + '@' + domain;
	// 	return maskedEmail;
	//  };

	const handleNoticationClose = () => {
		setNotificationRefundOpen(false)
		setOpenUpdateModal(false)
		setBulkStatusOpen(false)

		// setCheckValuesArr([])
	};

	const [viewTransactionDetailsResArray, setViewTransactionDetailResArray] =
		useState([]);


	const [viewInquiryDetailsResArray, setViewInquiryDetailsResArray] =
		useState([]);
	const [viewUpdateResArray, setViewUpdateResArray] =
		useState([]);

	const [bulkUpdateResArray, setBulkUpdateResArray] =
		useState([]);
	const [nextPageUntick, setNextPageUntick] = useState(false)
	const viewTransactionDetailsRes = useSelector(
		({ viewTransactionDetails }) => viewTransactionDetails
	);

	const inquiryDetailsRes = useSelector(
		({ partnerGetInquiryLists }) => partnerGetInquiryLists
	);

	const UpdateGatewayTransactionRes = useSelector(
		({ partnerUpdateGatewayTransactionStatus }) => partnerUpdateGatewayTransactionStatus
	);

	const BulkUpdateStatusPartnerRes = useSelector(
		({ partnerBulkUpdateStatusLists }) => partnerBulkUpdateStatusLists
	);
	const getUsernameSuggestionRes = useSelector(
		({ partnerGetUsernameContactSuggestionsLists }) => partnerGetUsernameContactSuggestionsLists
	)
	  const login = useSelector((state) => state.login);
	

	// console.log("inquiryDetailsResAbove", inquiryDetailsRes)
	const [open, setOpen] = useState(null);
	const [openPopup, setOpenPopUp] = useState(false)


	useEffect(() => {
		setInquiryOpenModal(false)

		return (() => {
			setInquiryOpenModal(false)
			dispatch(resetGetInquiry())

		})
	}, [])

	const classes = useStyles();
	const [orgnDesc, setorgnDesc] = useState("");
	const [getRemark, setGetRemark] = useState("");

	const [updateStatus, setUpdateStatus] = useState("");


	const [getWayTransactionListStatus, setgetWayTransactionListStatus] =
		useState(false);
	// const filterOptions = createFilterOptions({
	// 	matchFrom: "any",
	// 	limit: 500
	// });
	const inquiryHandleClick = (orgDesc) => {
		getInquiryReq(orgDesc)
		// getInquiryFunc()
	}

	const updateHandleClick = (
		orgnDesc
	) => {
		setorgnDesc(orgnDesc)
		setOpenUpdateModal(true)
	}



	const getUpdateGateWayReq = () => {
		const request = {
			actionCustomerMasterRequestVO: {
				status: updateStatus,
				orderDescription: orgnDesc,
				remark: getRemark,
				initiatedBy: "partner",
				walletOwnerId: regenerateTokenRes.data.partnerId
			}

		}
		// console.log("REQUESTTTTTT", request)
		dispatch(partnerUpdateGatewayTransactions(request, authToken));
	}

	const getUpdateGateWayFunc = () => {
		// console.log("UPDATEGATEWAYssss", UpdateGatewayTransactionRes)
		if (UpdateGatewayTransactionRes.data.status === "success") {
			// console.log("INSIDE CONSOLE SUCCESS")
			setViewUpdateResArray(
				UpdateGatewayTransactionRes.data
			);
			setNotificationRefundOpen(true)
			getgateWayTransactionListReq()
			// setInquiryOpenModal(true)


		}
		if (UpdateGatewayTransactionRes.data.status == "Failed") {
			setViewUpdateResArray(UpdateGatewayTransactionRes.data);
			setNotificationRefundOpen(true)
			if (
				UpdateGatewayTransactionRes.data.description == "session out"
			){
				SOLogout(dispatch, authToken, UpdateGatewayTransactionRes.data.partnerId);
			}
			if (
				UpdateGatewayTransactionRes.data.description == "Authorization failed"
			) {
				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
		}
		if (UpdateGatewayTransactionRes.data.status == "not found"){
			setViewUpdateResArray(UpdateGatewayTransactionRes.data);
			setNotificationRefundOpen(true)
			if (
				UpdateGatewayTransactionRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, UpdateGatewayTransactionRes.data.partnerId);
			}
			if (
				UpdateGatewayTransactionRes.data.description == "Authorization failed"
			) {
				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
		}
		if (UpdateGatewayTransactionRes.data.status == "failed"){
			setViewUpdateResArray(UpdateGatewayTransactionRes.data);
			setNotificationRefundOpen(true)
			if (
				UpdateGatewayTransactionRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, UpdateGatewayTransactionRes.data.partnerId);
			}
			if (
				UpdateGatewayTransactionRes.data.description == "Authorization failed"
			) {
				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
		}
	}
	useEffect(() => {
		getUpdateGateWayFunc();
	}, [UpdateGatewayTransactionRes]);

	useEffect(() => {


		dispatch(resetUpdateGatewayTransaction())
	}, [])
	useEffect(() => {
		setNotificationRefundOpen(false)

		return (() => {
			setNotificationRefundOpen(false)
			dispatch(resetUpdateGatewayTransaction())

		})
	}, [])

	useEffect(() => {
		if (UpdateGatewayTransactionRes.data.status) {

			setNotificationRefundOpen(true)
		}
		getUpdateGateWayFunc();
		// console.log("inside eff", UpdateGatewayTransactionRes);
	}, [UpdateGatewayTransactionRes]);

	const getInquiryReq = (orgDesc) => {
		const req = {
			actionCustomerMasterRequestVO: {
				orderDescription: orgDesc,

			}



		};
		return dispatch(
			getInquirys(
				req,
				regenerateTokenRes.data.AuthToken
			)
		);
	}

	useEffect(() => {


		dispatch(resetGetInquiry())
	}, [])


	const getInquiryFunc = () => {
		// console.log("inquiryDetailsRessssss", inquiryDetailsRes)
		if (inquiryDetailsRes.data.status === "Success") {
			// console.log("INSIDE CONSOLE SUCCESS")
			setViewInquiryDetailsResArray(
				inquiryDetailsRes.data.customerMasterDetailsRequestVO
			);
			// setInquiryOpenModal(true)


		}
		if (inquiryDetailsRes.data.status == "Failed") {
			setViewInquiryDetailsResArray(inquiryDetailsRes.data);
			if (
				inquiryDetailsRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, inquiryDetailsRes.data.partnerId);
			}
			if (
				inquiryDetailsRes.data.description == "Authorization failed"
			) {
				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
		}
		if (inquiryDetailsRes.data.status == "failed") {
			setViewInquiryDetailsResArray(inquiryDetailsRes.data);
			if (
				inquiryDetailsRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, inquiryDetailsRes.data.partnerId);
			}
			if (
				inquiryDetailsRes.data.description == "Authorization failed"
			) {
				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
		}
	}

	useEffect(() => {
		if (inquiryDetailsRes.data.status) {

			setInquiryOpenModal(true)
		}
		getInquiryFunc();
		// console.log("inside eff", inquiryDetailsRes);
	}, [inquiryDetailsRes]);






	// const getGateWayTransactionFunc = (transId, UserId) => {
	// 	const getGateWayTransactionReq = {
	// 		walletTransactionMasterDetailsRequestVO: {
	// 			walletOwnerId: regenerateTokenRes.data.partnerId || "",
	// 			transactionId: transId,
	// 			walletCustomerId: UserId
	// 		}
	// 	};

	// 	return dispatch(
	// 		getViewTransactionDetails(
	// 			getGateWayTransactionReq,
	// 			regenerateTokenRes.data.AuthToken
	// 		)
	// 	);
	// 	// console.log("///getViewTrans", getGateWayTransactionReq)
	// 	// console.log("emaillllss", viewTransactionDetailsResArray.custEmail)
	// };

	const handleChange = ({ target: { name, value } }) => {
		if (name === "customerId") {
			setCustomerId(value);
			// Util.verifyMobile(value) ? setCustomerId(value) : setCustomerId(customerId)
		}

		if (name === "transactionId") {
			// setTransactionId(value);
			Util.verifyMobile(value)
				? setTransactionId(value)
				: setTransactionId(transactionId);
		}

		if (name === "transactionType") {
			setTransactionType(value);
		}
		if (name === "transStatus") {
			setTransStatus(value);
		}
		if (name === "toCustContact") {
			setToCustContact(value);
		}
		if (name === "toCustName") {
			Util.verifyAlphabet(value)
				? setToCustName(value)
				: setToCustName(toCustName);
			// setToCustName(value);
		}
		if (name === "customerOrMobName") {
			// console.log("custttttNammmmee", customerOrMobName)
			setCustomerOrMobName(value)
		}
		if (name === "currency") {
			setCurrency(value);
		}

		if (name === "isFee") {
			setIsFee(value);
		}
		if (name === "getRemark") {
			// console.log("VALUESSSS", value)
			setGetRemark(value);
		}
		if (name === "orgnDesc") {
			// console.log("VALUESSSS", value)
			setorgnDesc(value);
		}
		if (name === "updateStatus") {
			setUpdateStatus(value);
			// setIsFee(value == "All" ? "" : value);
		}
	};
	// function countryFlag(cName) {
	// 	console.log("CNAME", cName)

	// 	let country = require("../../assets/img/CountryFlags/" + getCode(cName).toLowerCase() + ".png")
	// 	console.log("countryyyyy", country)
	// 	return country;
	// }
	// function countryFlag(cName) {
	// 	// console.log("CNAMESSSS", cName)
	// 	// console.log("COUNTRYESSSS", countries)
	// 	// const result = countries.filter(coun => coun.name === cName)
	// 	const result = countries.filter((Coun) => Coun.label === cName)


	// 	let country = require("../../assets/img/CountryFlags/" + (result[0].code).toLowerCase() + ".png")
	// 	console.log("CountryFilter", result)

	// 	// console.log("cnnnaaammee", cName)
	// 	return country;
	// }
	// function countryFlag(cNames) {
	// 	console.log("cnnnaaammee", cNames)
	// 	let country = require("../../assets/img/CountryFlags/" + getCode(cNames).toLowerCase() + ".png")
	// 	console.log("COUNTRYYYYY", country)

	// 	return country;
	// }

	function countryFlagShow(countryNameLists) {
		// console.log("CNNNAAAMMEEESLISTTT Before", countryNameLists)

		countryNameLists = countryNameLists.replace(/\w+/g,
			function (w) { return w[0].toUpperCase() + w.slice(1).toLowerCase(); });
		// console.log("CNNNAAAMMEEESLISTTT After", countryNameLists)


		// console.log("COUNTRYYYYY", country)
		let countryS = require("../../assets/img/CountryFlags/" + getCodes(countryNameLists).toLowerCase() + ".png")
		// console.log("COUNTRYYYYY", country)

		return countryS;
	}

	const getTransactionTypeListRes = useSelector(
		({ getTransactionTypeList }) => getTransactionTypeList
	);

	const getWayTransactionListRes = useSelector(
		({ getWayTransactionList }) => getWayTransactionList
	);
	const getUsernameContactSuggestionRes = useSelector(
		({ partnerGetUsernameContactSuggestionsLists }) => partnerGetUsernameContactSuggestionsLists
	)

	// console.log(getWayTransactionListRes + "getWayTransactionListRes");
	// console.log("getWayTransactionListRes" + getWayTransactionListRes);
	const [CustId, setCustId] = useState("");
	const [UserId, setUserId] = useState("");
	const [transId, setTransId] = useState('')
	// const [FromCustID, setFromCustID] = useState('')

	const onButtonClick = (transId, UserId) => {
		// console.log("transIddddd", transId)
		// console.log("UserId", UserId)
		if (open == transId) {
			setOpen(null)
		}
		else {
			setIsMaskedEmail(true)
			setOpen(transId)
		}
		setTransId(transId)
		setUserId(UserId)
		// setCustId(CustId)
		getGateWayTransactionFunc(transId, UserId)

		// console.log("btnnnn", FromCustID)

	};
	// useEffect(() => {
	// 	if (regenerateTokenRes.data.status == "success") {
	// 		const getUserContactReq = {
	// 			actionCustomerMasterRequestVO: {
	// 				customerMobileOrName: customerOrMobName,
	// 				walletOwnerId: regenerateTokenRes.data.partnerId || ""
	// 			}
	// 		}
	// 		dispatch(getUserNameContactSuggestionList(getUserContactReq, authToken))
	// 		// console.log("userContact", getUserContactReq)
	// 	}
	// }, [regenerateTokenRes.data.status])
	const getGateWayTransactionFunc = (transId, UserId) => {
		const getGateWayTransactionReq = {
			walletTransactionMasterDetailsRequestVO: {
				// walletOwnerId: regenerateTokenRes.data.partnerId || "",
                walletOwnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId,
				transactionId: transId,
				walletCustomerId: UserId
			}
		};

		return dispatch(
			getViewTransactionDetails(
				getGateWayTransactionReq,
				regenerateTokenRes.data.AuthToken
			)
		);
		// console.log("///getViewTrans", getGateWayTransactionReq)
		// console.log("emaillllss", viewTransactionDetailsResArray.custEmail)
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getGateWayTransactionFunc();
		}
	}, [customerId, regenerateTokenRes.data.status]);

	const viewTransactionDetailsResFunc = () => {
		if (viewTransactionDetailsRes.data.status == "success") {
			setViewTransactionDetailResArray(
				viewTransactionDetailsRes.data.transactionMasterDetailsResponseVO
			);
		}
		if (viewTransactionDetailsRes.data.status == "Failed") {
			setViewTransactionDetailResArray(viewTransactionDetailsRes.data);
			if (
				viewTransactionDetailsRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
			if (
				viewTransactionDetailsRes.data.description == "Authorization failed"
			) {
				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
		}
	};

	useEffect(() => {
		viewTransactionDetailsResFunc();
	}, [viewTransactionDetailsRes.data.status]);

	const getTransactionTypeList = () => {
		if (getWayTransactionListStatus) {
			if (getWayTransactionListRes.data.status == "success") {
				setIsLoading(false);
				setGetTransactionTypeListResArray(
					[].concat(getWayTransactionListRes.data.transactionList)
				);
			} else {
				setIsLoading(false);
				setGetTransactionTypeListResArray(getWayTransactionListRes.data);
				if (openPopup) {
					NotificationPopups(
						"error",
						"Failed",
						getWayTransactionListRes.data.description
					);
					setOpenPopUp(false)
				}
				// NotificationPopups(
				// 	"error",
				// 	"Failed",
				// 	getWayTransactionListRes.data.description
				// );
				// setgetWayTransactionListStatus(getWayTransactionListRes.data);
			}
		}
	};

	// useEffect(() => {
	// 	if (getWayTransactionListRes.data.status == "success") {
	// 		// setPage(0);
	// 	}
	// }, [getWayTransactionListRes.data.status]);

	useEffect(() => {
		if (getWayTransactionListRes.data.status) {
			getTransactionTypeList();
		}
	}, [getWayTransactionListRes.data.status]);

	const handleDateChange = (date) => {
		if(date > selectedDate){
			setSelectedToDate(selectedDate);
		}
		setSelectedDate(date);
	};

	const handleToDateChange = (date) => {
		setSelectedToDate(date);
	};

	const getCountryCodeFunc = (details, sel) => {
		if (!details) {
			return '';
		} else {
			let res = details.filter(ch => ch.mobile === sel)
			if (res.length == 0) {
				return '';
			} else {
				return res[0].countryCode;
			}
		}
	}

	const getgateWayTransactionListReq = () => {
		setIsLoading(true);
		setgetWayTransactionListStatus(true);
		const getgateWayTransactionListReq = {
			walletTransactionMasterDetailsRequestVO: {
				// walletOwnerId: regenerateTokenRes.data.partnerId || "",
                walletOwnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId,

				fromDate: moment(selectedDate).format("DD/MM/YYYY"),
				toDate: moment(selectedToDate).format("DD/MM/YYYY"),
				transactionId: transactionId,
				// transactionType: transactionType,
				transactionType: transactionType == "All" ? "" : transactionType,
				toCustomerContact: getCountryCodeFunc(getUsernameContactSuggestionRes.data.list, customerOrMobName.split("-")[0])
					? getCountryCodeFunc(getUsernameContactSuggestionRes.data.list, customerOrMobName.split("-")[0])
					+ ' ' + customerOrMobName.split("-")[0] : customerOrMobName.split("-")[0],
				// toCustomerContact: customerOrMobName.split("-")[0],
				toCustomerName: toCustName,
				transactionStatus: transStatus === "All" ? "" : transStatus,
				// pageNo: transactionId ? 1 : pageNo + 1,
				pageNo: pageNoOne() ? 1 : pageNo + 1,
				records: rowsPerPage
			}
		};
		// console.log('getgateWayTransactionListReq: ', getgateWayTransactionListReq)
		setOpenPopUp(true)
		return dispatch(
			getWayTransactionList(getgateWayTransactionListReq, authToken)
		);
	};

	// useEffect(() => {
	// 	if (regenerateTokenRes.data.status == "success") {
	// 		getgateWayTransactionListReq();
	// 	}
	// }, [regenerateTokenRes.data.status]);
	// IF ANY ONE ENTITY FOUND THEN PAGE NUMBER 1 GOING TO getgateWayTransactionListReq THIS REQUEST
	function pageNoOne() {
		if (transactionType || transStatus || toCustName || transactionId || getCountryCodeFunc()) {
			return 1
		} else {
			return 0
		}
	}


	useEffect(() => {
		if (getWayTransactionListRes.data.status === "success") {
			getgateWayTransactionListReq();
		}
	}, [pageNo, rowsPerPage])

	useEffect(() => {
		return (() => {
			dispatch(resetGetWayTransactionList())
		})
	}, [])

	// useEffect(() => {
	// 	return () => {
	// 		dispatch(resetGetWayTransactionList())
	// 	}
	// }, [])
	const handleChangePageForward = (pageaa, newPage) => {
		setPageNo(newPage);
		setNextPageUntick(false)

		// getWalletTransactionListReq()
		// console.log("Arrow", newPage)
	};

	const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        const currentFirstRowIndex = pageNo * rowsPerPage;
        const newPage = Math.floor(currentFirstRowIndex / newRowsPerPage);
   
        setRowsPerPage(newRowsPerPage);
        setPageNo(newPage);
    };

	// const handleChangePage = (event, newPage) => {
	// 	setPage(newPage);
	// };

	// const handleChangeRowsPerPage = (event) => {
	// 	setRowsPerPage(parseInt(event.target.value, 10));
	// 	setPage(0);
	// };

	// const gateWayTransactionDetails = (id, customerId) => {
	// 	navigate.push({
	// 		// pathname: `/index/getWatTransactionDetails`,
	// 		pathname: `/index/getTransactionDetails`,
	// 		state: { param1: `${id}`, param2: `${customerId}` }
	// 	});
	// };
	useEffect(() => {
		if (getUsernameContactSuggestionRes.data.status === "success") {
			// console.log("lissttt", getUsernameContactSuggestionRes.data.list)
		}
	}, [getUsernameContactSuggestionRes.data.status])

	useEffect(() => {
		if (getUsernameSuggestionRes.data.status === "success") {
			// console.log("lissttt", getUsernameSuggestionRes.data.list)
		}
	}, [getUsernameSuggestionRes.data.status])

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			const getUserContactReq = {
				actionCustomerMasterRequestVO: {
					customerMobileOrName: customerOrMobName,
					walletOwnerId: regenerateTokenRes.data.partnerId || ""
				}
			}
			dispatch(getUserNameContactSuggestionList(getUserContactReq, authToken))
			// console.log("userContact", getUserContactReq)
		}
	}, [regenerateTokenRes.data.status])

	const filterOptions = (options, { inputValue }) => {
		if (inputValue.length < 3) {
			return [];
		}

		const filteredOptions = options.filter(
			(option) =>
				option.mobile ? option.mobile.includes(inputValue) : '' ||
					option.customerMobileOrName ? option.customerMobileOrName.includes(inputValue) : ''
		);

		return filteredOptions.slice(0, 20);
	}

	//Customer/Beneficiery name autocomplete
	const filterOptionsN = (options, { inputValue }) => {
		if (inputValue.length < 3) {
			return [];
		}

		const filteredOptionsNames = options.filter(
			(option) =>

				option.customerMobileOrName && option.customerMobileOrName.includes(inputValue)
		);

		return filteredOptionsNames.slice(0, 20);
	}
	const handleClose = () => {
		setInquiryOpenModal(false)
		setOpenUpdateModal(false)

	}


	const [checkBox, setCheckBox] = useState(false)
	const [selectAll, setSelectAll] = useState(false)
	const [checkValuesArr, setCheckValuesArr] = useState([])
	const [checkValueStatus, setCheckValueStatus] = useState([])

	const getBulkUpdateStatusReq = () => {
		const req = {
			actionCustomerMasterRequestVO: {
				mappingIdList: checkValuesArr,
				walletOwnerId: regenerateTokenRes.data.partnerId
			}
		}
		// console.log("REQ", req)
		dispatch(partnerBulkUpdateStatus(req, authToken));

	}

	const getBulkUpdateStatusFunc = () => {
		// console.log("UPDATEGATEWAYBulk", BulkUpdateStatusPartnerRes)
		if (BulkUpdateStatusPartnerRes.data.status === "success") {
			// console.log("INSIDE CONSOLE SUCCESS")
			setCheckValueStatus(BulkUpdateStatusPartnerRes.data);
			setBulkStatusOpen(true)



			// setCheckValuesArr(
			// 	[].concat(BulkUpdateStatusPartnerRes.data.CustomerMasterDetailsRequestVO)
			// );



		}
		if (BulkUpdateStatusPartnerRes.data.status === "Failed") {
			setCheckValueStatus(BulkUpdateStatusPartnerRes.data);
			// setCheckValuesArr([].concat(BulkUpdateStatusPartnerRes.data));
			setBulkStatusOpen(true)

			if (
				BulkUpdateStatusPartnerRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, BulkUpdateStatusPartnerRes.data.partnerId);
			}
			if (
				BulkUpdateStatusPartnerRes.data.description == "Authorization failed"
			) {
				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
		}
		if (BulkUpdateStatusPartnerRes.data.status === "not found") {
			setCheckValueStatus(BulkUpdateStatusPartnerRes.data);

			// setCheckValuesArr([].concat(BulkUpdateStatusPartnerRes.data.CustomerMasterDetailsRequestVO));
			setBulkStatusOpen(true)


			if (
				BulkUpdateStatusPartnerRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, BulkUpdateStatusPartnerRes.data.partnerId);
			}
			if (
				BulkUpdateStatusPartnerRes.data.description == "Authorization failed"
			) {
				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
		}
		if (BulkUpdateStatusPartnerRes.data.status == "failed") {
			setCheckValuesArr(BulkUpdateStatusPartnerRes.data);

			// setCheckValuesArr([].concat(BulkUpdateStatusPartnerRes.data));
			setBulkStatusOpen(true)

			if (
				BulkUpdateStatusPartnerRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, BulkUpdateStatusPartnerRes.data.partnerId);
			}
			if (
				BulkUpdateStatusPartnerRes.data.description == "Authorization failed"
			) {
				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
		}
	}
	useEffect(() => {
		getBulkUpdateStatusFunc();
	}, [BulkUpdateStatusPartnerRes]);

	useEffect(() => {
		setCheckValuesArr([])

	}, [pageNo])
	const handleCheckbox = (event) => {
		// console.log("EVEent", event.target.checked)
		const { name, checked } = event.target;
		setCheckBox(checked)
		if (checked) {
			let checkarr = getTransactionTypeListResArray &&
				[]
					.concat(getTransactionTypeListResArray)
					.map((ele) => {
						return ele.transactionId
					})
			setCheckValuesArr([...checkarr])
			// console.log("CHECKEDDDD", checkarr)
		}
		else {
			setCheckValuesArr([])
		}
	};
	// console.log("CHECKEDDD", checkBox)
	// console.log("TICK", checkValuesArr)
	const handleSingleCheckbox = (e, transactionId) => {
		// console.log("TRansactionID", transactionId)

		if (e.target.checked && !checkValuesArr.includes(transactionId)) {
			setCheckValuesArr([...checkValuesArr, transactionId])
		}
		else {
			let filterArr = checkValuesArr.filter((el) => {
				return el != transactionId
			})
			setCheckValuesArr([...filterArr])

		}

	}
	useEffect(() => {
		dispatch(resetBulkUpdateStatusPartner())
	}, [])
	useEffect(() => {
		setBulkStatusOpen(false);


		return () => {
			setBulkStatusOpen(false);

			dispatch(resetBulkUpdateStatusPartner())
		}
	}, [])
	// const handleCheckbox = (index) => {
	// 	const newValues = [...checkBox];
	// 	newValues[index] = !newValues[index];
	// 	setCheckboxValues(newValues);
	//   };



	// useEffect(() => {
	// 	if (regenerateTokenRes.data.status == "success") {
	// 		const getUserContactReq = {
	// 			actionCustomerMasterRequestVO: {
	// 				customerMobileOrName: customerOrMobName,
	// 				walletOwnerId: regenerateTokenRes.data.partnerId || ""
	// 			}
	// 		}
	// 		dispatch(getUserNameContactSuggestionList(getUserContactReq, authToken))
	// 		// console.log("userContact", getUserContactReq)
	// 	}
	// }, [regenerateTokenRes.data.status])

	return (
		<>
			<Layout>
				<Card>
					{/* <BackButton /> */}
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<FormControl fullWidth>
								 <LocalizationProvider dateAdapter={AdapterDateFns}>
									<DatePicker
										label="From Date"
										format="MM/dd/yyyy"
										value={selectedDate}
										onChange={handleDateChange}
										disableFuture={true}
									/>
								  </LocalizationProvider>
							</FormControl>
						</Grid>

						<Grid item xs={12} sm={12} md={3} lg={3}>
							<FormControl fullWidth>
								 <LocalizationProvider dateAdapter={AdapterDateFns}>
									<DatePicker
										label="To Date"
										format="MM/dd/yyyy"
										value={selectedToDate}
										onChange={handleToDateChange}
										disableFuture={true}
										minDate={selectedDate}
									/>
								  </LocalizationProvider>
							</FormControl>
						</Grid>

						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Transaction Id"
								type="tel"
								fullWidth
								value={transactionId}
								name="transactionId"
								onChange={handleChange}
								style={{ marginTop: "3px" }}
								variant="standard"
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</Grid>

						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								select
								autoFocus
								margin="dense"
								id="name"
								label="Transaction Type"
								type="tel"
								fullWidth
								style={{ marginTop: "3px" }}
								// value={transactionType}
								name="transactionType"
								onChange={handleChange}
								defaultValue={"All" || transactionType}
								variant="standard"
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}

							>
								<MenuItem value="All" selected="All">
									All
								</MenuItem> N
								<MenuItem value="LOAD">LOAD</MenuItem>
								<MenuItem value="LOAD">REFUND</MenuItem>
								{/* <MenuItem value="VOUCHER PURCHASE">VOUCHER PURCHASE</MenuItem> */}
							</TextField>
						</Grid>
						{/* <Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Customer Name"
								type="tel"
								fullWidth
								value={toCustName}
								name="toCustName"
								onChange={handleChange}
								style={{ marginTop: "3px" }}
							/>
						</Grid> */}
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<Autocomplete
								id="combo-box-demo"
								options={[].concat(
									getUsernameSuggestionRes.data.list || [""]
								)}
								getOptionLabel={(option) => option.customerMobileOrName}
								filterOptions={filterOptionsN}
								renderInput={(params) => (
									<TextField
										autoFocus
										margin="dense"
										id="name"
										label="Name"
										style={{ marginTop: "3px" }}
										type="text"
										fullWidth
										{...params}
										value={toCustName || ""}
										name="toCustName"
										onBlur={handleChange}
								variant="standard"
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}

									/>
								)}
							/>
							{/* <TextField
									autoFocus
									margin="dense"
									id="name"
									label="Beneficiary Name"
									type="tel"
									fullWidth
									value={toCustName}
									name="toCustName"
									onChange={handleChange}
									style={{ marginTop: "3px" }}
								/> */}

						</Grid>

						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								select
								autoFocus
								margin="dense"
								id="name"
								label="Transaction Status"
								type="tel"
								fullWidth
								style={{ marginTop: "3px" }}
								// value={transactionType}
								name="transStatus"
								onChange={handleChange}
								defaultValue={"All" || transStatus}
								variant="standard"
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}

							>
								<MenuItem value="All" selected="All">
									All
								</MenuItem>
								<MenuItem value="Success">Success</MenuItem>
								<MenuItem value="Failed">Failed</MenuItem>
								<MenuItem value="Pending">Pending</MenuItem>
								<MenuItem value="Cancelled">Cancelled</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<Autocomplete
								id="combo-box-demo"
								options={[].concat(
									// getUsernameContactSuggestionRes.data.list && getUsernameContactSuggestionRes.data.list || [""]
									getUsernameContactSuggestionRes.data.list || [""]
								)}
								getOptionLabel={(option) => option.mobile + "-" + option.customerMobileOrName}
								filterOptions={filterOptions}
								renderInput={(params) => (
									<TextField
										autoFocus
										style={{ marginTop: "3px" }}
										variant="standard"

										margin="dense"
										id="name"
										label="Customer Mob no"
										// required
										type="text"
										fullWidth
										{...params}
										value={customerOrMobName || ""}
										name="customerOrMobName"
										onBlur={handleChange}
										sx={{
											"& .MuiInput-underline:before": {
											  borderBottomColor: "gray", // White color for the underline before focus
											},
											"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
											  borderBottomColor: "gray", // White color on hover
											},
											"& .MuiInput-underline:after": {
											  borderBottomColor: "gray", // White color after focus
											},
										  }}
									/>
								)}

							/>
						</Grid>
					</Grid>

					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1.5rem",
							marginBottom: "15px"
						}}
					>
						<Grid item md={5}>

							<CustomButton
								style={{
									padding: "8px",
									marginLeft: "15px"
								}}
								onClick={getgateWayTransactionListReq}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
						<Grid item md={7}></Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getTransactionTypeListResArray.length == undefined ||
					!getWayTransactionListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Transaction List
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Transaction List
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table className={classes.table}>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>

												<input type="checkbox"
													name="allValues"
													checked={checkBox && nextPageUntick}
													onChange={(e) => { handleCheckbox(e); setNextPageUntick(true) }}
												></input>

											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												{" "}

											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Transaction Id{" "}
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												{" "}
												Order Description
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												{" "}
												From Customer Name
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												{" "}
												Transaction Status
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Transaction Type
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Transaction Amount
											</TableCell>
											{/* <TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Transaction Currency
											</TableCell> */}
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Transaction Date
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{getTransactionTypeListResArray &&
											[]
												.concat(getTransactionTypeListResArray)
												// .slice(
												// 	page * rowsPerPage,
												// 	page * rowsPerPage + rowsPerPage
												// )
												.map((row, index) => (
													<>
														<TableRow key={index}>
															{/* <TableCell>
                                <CustomButton
                                  style={{
                                    marginTop: "1rem",
                                    marginLeft: "1rem",
                                  }}
                                  onClick={() =>
                                    gateWayTransactionDetails(
                                      row.transactionId,
                                      row.toCustomerId
                                    )
                                  }
                                >
                                  {row.transactionId}
                                </CustomButton>

                              </TableCell> */}
															<TableCell align="center" style={{ borderBottom: "0" }}>
																<input type="checkbox"
																	name="checkbox"
																	checked={[].concat(checkValuesArr).includes(row.transactionId)}
																	onChange={(e) => handleSingleCheckbox(e, row.transactionId)}
																></input>
															</TableCell>
															<TableCell style={{ borderBottom: "0" }}>
																<IconButton
																	aria-label="expand row"
																	size="small"
																	onClick={() => onButtonClick(row.transactionId, row.toCustomerId)}
																>
																	{open == row.transactionId ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
																</IconButton>
															</TableCell>
															<TableCell
																align="center"
																className=""
																style={{ borderBottom: "0" }}
															// style={{
															// 	marginTop: "1rem",
															// 	// marginLeft: "rem",
															// 	// color: "#00b9f5",
															// 	cursor: "pointer",
															// 	fontWeight: "600"
															// }}
															// onClick={() =>
															// 	gateWayTransactionDetails(
															// 		row.transactionId,
															// 		row.toCustomerId
															// 	)
															// }
															>
																{row.transactionId}
															</TableCell>

															<TableCell align="center" style={{ borderBottom: "0" }}>
																{row.orderDescription}
															</TableCell>
															<TableCell align="center" style={{ borderBottom: "0" }}>
																{row.fromCustomerName}
															</TableCell>
															<TableCell align="center" style={{ borderBottom: "0" }}>
																{row.transactionStatus}
															</TableCell>
															<TableCell align="center" style={{ borderBottom: "0" }}>
																{row.transactionType}</TableCell>
															<TableCell align="center" style={{ borderBottom: "0" }}>
																{" "}
																{getSymbolFromCurrency(row.currency) +
																	" " + row.transactionAmount}
																{/* {row.transactionAmount} */}
															</TableCell>
															{/* <TableCell align="center" style={{ borderBottom: "0" }}>
																{" "}
																{row.currency}
															</TableCell> */}
															<TableCell align="center" style={{ borderBottom: "0" }}>
																{" "}
																{row.fromDate}
															</TableCell>

															<TableCell align="center">
																<Grid xs={12} sm={12} md={12} lg={12} style={{ display: "flex" }}>
																	{/* {console.log("ORDER DESSSS", row.orderDescription)} */}
																	{/* {console.log("TRANSTYPE", row.transactionType === "REFUND")} */}
																	{row.transactionType === "REFUND" ?
																		<Tooltip title="Inquiry">
																			<CustomButton
																				disabled={true}

																				// disabled={row.transactionStatus !== "Pending"}
																				style={{
																					padding: "8px"
																				}}


																				onClick={() =>
																					inquiryHandleClick(row.orderDescription)
																				}


																			>

																				<FindInPageIcon
																					style={{
																						color: "#fff",
																						fontSize: "20px"
																					}}
																				/>
																			</CustomButton>
																	 </Tooltip>
																		 :

																		<Tooltip title="Inquiry">
																			<CustomButton
																				disabled={(row.transactionStatus == "Pending") || (row.transactionStatus == "Success") ? false : true}

																				// disabled={row.transactionStatus !== "Pending"}
																				style={{
																					padding: "8px"
																				}}


																				onClick={() =>
																					inquiryHandleClick(row.orderDescription)
																				}


																			>

																				<FindInPageIcon
																					style={{
																						color: "#fff",
																						fontSize: "20px"
																					}}
																				/>
																			</CustomButton>
																	</Tooltip>
																		}
																	
																	<Tooltip title="Update">
																		<CustomButton
																			// disabled={(row.transactionStatus == "Pending" || row.transactionStatus == "Success") ? false : true}
																			disabled={row.transactionStatus !== "Pending" || row.transactionType === "REFUND"}
																			style={{
																				padding: "8px",
																				marginLeft: "10px"
																			}}


																			onClick={() =>
																				updateHandleClick(row.orderDescription)
																			}


																		>

																			<EditIcon
																				style={{
																					color: "#fff",
																					fontSize: "20px"
																				}}
																			/>
																		</CustomButton>
																		</Tooltip>
															
																</Grid>


															</TableCell>
														</TableRow>
														<TableRow>
															<TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
																<Collapse
																	in={open == row.transactionId || row.customerId}

																	timeout="auto"
																	// onClick={() => onButtonClick(row.fromCustomerId
																	// )}
																	unmountOnExit
																>
																	<Box margin={4}>
																		{/* <TableContainer
																		component={Paper}
																		style={{
																			marginBottom: "30px"
																		}}
																	> */}
																		{viewTransactionDetailsRes.data
																			.transactionMasterDetailsResponseVO &&
																			viewTransactionDetailsRes.data
																				.transactionMasterDetailsResponseVO ? (
																			<>
																				{viewTransactionDetailsResArray && (
																					<Table
																						className={classes.table}
																						aria-label="a dense table"
																						style={{ whiteSpace: "nowrap" }}
																					>
																						{/* <TableHead>
																							<TableRow className="themeBackground">
																								<TableCell
																									align="center"
																									style={{ fontWeight: "bold", color: "white" }}
																								>
																									Tracking Id{" "}
																								</TableCell>
																								<TableCell
																									align="center"
																									style={{ fontWeight: "bold", color: "white" }}
																								>
																									Payment Id
																								</TableCell>
																								<TableCell
																									align="center"
																									style={{ fontWeight: "bold", color: "white" }}
																								>
																									Purchase Amount
																								</TableCell>
																								<TableCell
																									align="center"
																									style={{ fontWeight: "bold", color: "white" }}
																								>
																									Currency
																								</TableCell>
																								<TableCell
																									align="center"
																									style={{ fontWeight: "bold", color: "white" }}
																								>
																									Status
																								</TableCell>
																								<TableCell
																									align="center"
																									style={{ fontWeight: "bold", color: "white" }}
																								>
																									Date
																								</TableCell>
																							</TableRow>
																						</TableHead> */}

																						<TableBody>
																							{viewTransactionDetailsResArray &&
																								[]
																									.concat(viewTransactionDetailsResArray)
																									.map((row, index) => (
																										<TableRow key={index}>
																											<Row>
																												<Col md={12}>
																													<Typography
																														variant="h6"
																														component="div"
																														className="mt-1"
																														style={{
																															fontSize: "1.4rem",
																															// paddingTop: "1%",
																															// paddingBottom: "1.5%",

																														}}
																													>
																														Customer Details
																													</Typography>
																													<hr className="brightcolor" />
																													<Row >
																														<Col md={6} class="detail-info row">
																															<Row>

																																<Col md={6}>Customer Id	</Col>
																																<Col md={6}>

																																	{!row.toCustomerId || row.toCustomerId == ""
																																		? "-"
																																		: row.toCustomerId}
																																</Col>
																															</Row>
																														</Col>



																														<Col md={6} class="detail-info row">
																															<Row>

																																<Col md={6}>Customer Name</Col>
																																<Col md={6}>
																																	{!row.fromCustomerName || row.fromCustomerName == ""
																																		? "-"
																																		: row.fromCustomerName}
																																</Col>
																															</Row>
																														</Col>
																													</Row>
																													<hr />
																													<Row>
																														<Col md={6} class="detail-info row">
																															<Row>

																																<Col md={6}>Country Code</Col>
																																<Col md={6}> {!row.manualCode || row.manualCode == "" ? "-" : row.manualCode}</Col>

																															</Row>
																														</Col>



																														<Col md={6} class="detail-info row">
																															<Row>

																																<Col md={6}>Customer Email</Col>
																																{/* <Col md={6}>
																																	{" "}
																																	{!row.custEmail || row.custEmail == ""
																																		? "-"
																																		: row.custEmail}
																																</Col> */}
																																<Col md={5}>



																																	{/* {isMaskedEmail ? row.custEmail.substring(0, row.custEmail.lastIndexOf("@")) + "xxxx" + row.custEmail.substring(row.custEmail.lastIndexOf("@"), row.custEmail.length) : row.custEmail} */}
																																	{/* {isMaskedEmail ? row.custEmail.substring(0, 1) + "xxxx." + row.custEmail.substring(row.custEmail.lastIndexOf("@"), row.custEmail.length) : row.custEmail} */}
																																	{row.custEmail && isMaskedEmail ? row.custEmail.substring(0, 1) + "xxxx" + row.custEmail.substring(row.custEmail.lastIndexOf("@"), row.custEmail.length) : row.custEmail}







																																	{/* {
																																		isMaskedEmail ? row.custEmail.split("@")[0] + "xxxxx" + row.custEmail.substring(row.custEmail.lastIndexOf("@") + 1) : row.custEmail
																																	} */}

																																</Col>

																																<Col md={1}><span style={{ cursor: "pointer" }} onClick={() => setIsMaskedEmail(!isMaskedEmail)}> {isMaskedEmail ? <VisibilityOff className="EyeIcons" /> : <Visibility className="EyeIcons" />}
																																</span> </Col>

																															</Row>
																														</Col>
																													</Row>
																													<hr/>
																													<Row >
																														<Col md={6} class="detail-info row">
																															<Row>

																																<Col md={6}>From contact</Col>
																																<Col md={6}>

																																	{!row.fromContact || row.fromContact == ""
																																		? "-"
																																		: row.fromContact}
																																</Col>
																															</Row>
																														</Col>



																														<Col md={6} class="detail-info row">
																															<Row>

																																<Col md={6}>Beneficiery Contact</Col>
																																<Col md={6}>
																																	{!row.toCustomerContact || row.toCustomerContact == ""
																																		? "-"
																																		: row.toCustomerContact}
																																</Col>
																															</Row>
																														</Col>
																													</Row>


																												</Col>
																											</Row>

																											<Row>
																												<Col md={12}>
																													<Typography
																														variant="h6"
																														component="div"
																														className="mt-3"
																														style={{
																															fontSize: "1.4rem",
																															// paddingTop: "3.5%",
																															// paddingBottom: "1.5%",
																														}}
																													>
																														Transaction Details
																													</Typography>
																													<hr />
																													<Row>
																														<Col md={6} class="detail-info row">
																															<Row>

																																<Col md={6}>Transaction Id</Col>
																																<Col md={6}>
																																	{!row.transactionId || row.transactionId == ""
																																		? "-"
																																		: row.transactionId}
																																</Col>
																															</Row>
																														</Col>



																														<Col md={6} class="detail-info row">
																															<Row>

																																<Col md={6}>Payment Id</Col>
																																<Col md={6}>
																																	{!row.paymentId || row.paymentId == ""
																																		? "-"
																																		: row.paymentId}
																																</Col>
																															</Row>
																														</Col>
																													</Row>
																													<hr  />
																													<Row>
																														<Col md={6} class="detail-info row">
																															<Row>

																																<Col md={6}>Purchase Amount</Col>
																																<Col md={6}>
																																	{!row.transactionAmount || row.transactionAmount == ""
																																		? "-"
																																		: row.transactionAmount}
																																</Col>
																															</Row>
																														</Col>



																														<Col md={6} class="detail-info row">
																															<Row>

																																<Col md={6}>Currency</Col>
																																<Col md={6}>
																																	{!row.currency || row.currency == ""
																																		? "-"
																																		: row.currency}
																																</Col>
																															</Row>


																														</Col>
																													</Row>
																													<hr />
																													<Row>
																														<Col md={6} class="detail-info row">
																															<Row>

																																<Col md={6}>Status</Col>
																																<Col md={6}>
																																	{!row.transactionStatus || row.transactionStatus == ""
																																		? "-"
																																		: row.transactionStatus}
																																</Col>
																															</Row>
																														</Col>
																														<Col md={6} class="detail-info row">
																															<Row>

																																<Col md={6}>Transaction SubType</Col>
																																<Col md={6}>
																																	{!row.transactionSubType || row.transactionSubType == ""
																																		? "-"
																																		: row.transactionSubType}
																																</Col>
																															</Row>
																														</Col>



																														{/* <Col md={6} class="detail-info row">
																															<Row>

																																<Col md={6}>Date</Col>
																																<Col md={6}>
																																	{!row.timestamp || row.timestamp == ""
																																		? "-"
																																		: row.timestamp}
																																</Col>
																															</Row>


																														</Col> */}
																													</Row>
																													<hr />

																												</Col>

																											</Row>
																											{(row.firstSix === '-' || row.firstSix === '') && (row.lastFour === '-' || row.lastFour === '') && (row.cardHolderName === '-' || row.cardHolderName === '')
																												&& (row.binCountry === '-' || row.binCountry === '')
																												? '' :
																												<Row>
																													<Col md={12}>
																														<Typography
																															variant="h6"
																															component="div"
																															className="mt-3"
																															style={{
																																fontSize: "1.4rem",
																															}}
																														>
																															Account Details
																														</Typography>
																														<hr />
																														<Row >
																															<Col md={6} class="detail-info row">
																																<Row>

																																	<Col md={6}>Account Holder</Col>
																																	<Col md={6}>
																																		{!row.cardHolderName || row.cardHolderName == ""
																																			? "-"
																																			: row.cardHolderName}

																																	</Col>
																																</Row>
																															</Col>
																															<Col md={6} class="detail-info row">
																																<Row>

																																	<Col md={6}>Account Number</Col>
																																	<Col md={6}>
																																		{/* {!row.firstSix + "xxxx" + !row.lastFour ||
																											row.firstSix + "xxxx" + row.lastFour === "" ? "-"
																											: row.firstSix + "xxxx" + row.lastFour} */}
																																		{!row.firstSix + !row.lastFour ||
																																			row.firstSix + row.lastFour === "" ? "-"
																																			: row.firstSix + "XXXXXX" + row.lastFour}

																																	</Col>
																																</Row>
																															</Col>
																															{/* <Col md={6} class="detail-info row">
																																<Row>
																																	<Col md={6}>Bin Country</Col>
																																	<Col md={6}>

																																		{!row.binCountry || row.binCountry == ""
																																			? "-"
																																			: row.binCountry}

																																	</Col>
																																</Row>
																															</Col> */}
																														</Row>
																														<hr />
																														<Row>
																															<Col md={6} class="detail-info row">
																																<Row>

																																	<Col md={6}>Bin Country</Col>
																																	{/* {console.log("PassBinCountry", row.binCountry)} */}
																																	{/* <Col md ={6}>
																																		{row.binCountry === "-" ? "" :}
																																	</Col> */}
																																	<Col md={6}>
																																		{/* {console.log("PassBinCountry", row.binCountry)} */}
																																		{row.binCountry === "-" ? "" : row.binCountry ?


																																			(
																																				<div>
																																					<img src={countryFlagShow(row.binCountry)} style={{ height: "20px", width: "20px", marginRight: "10px" }} />
																																					<span>{row.binCountry}</span>
																																				</div>
																																			)
																																			: ""}
																																	</Col>

																																	{/* <Col md={6}>

																																		{!row.binCountry || row.binCountry == ""
																																			? "-"
																																			: row.binCountry}

																																	</Col> */}

																																</Row>
																															</Col>
																														</Row>
																														{/* <Row >
																															<Col md={6} class="detail-info row">
																																<Row>

																																	<Col md={6}>First Six</Col>
																																	<Col md={6}>
																																		{!row.firstSix || row.firstSix == ""
																																			? "-"
																																			: row.firstSix}
																																	</Col>
																																</Row>
																															</Col>
																															<Col md={6} class="detail-info row">
																																<Row>
																																	<Col md={6}>Last Four</Col>
																																	<Col md={6}>
																																		{!row.lastFour || row.lastFour == ""
																																			? "-"
																																			: row.lastFour}
																																	</Col>
																																</Row>
																															</Col>
																														</Row> */}
																														<hr />

																													</Col>
																												</Row>
																											}

																											{/* {(row.firstSix === '-' || row.firstSix === '') && (row.lastFour === '-' || row.lastFour === '') && (row.cardHolderName === '-' || row.cardHolderName === '') ? '' :
																												<Row>
																													<Col md={12}>
																														<Typography
																															variant="h6"
																															component="div"
																															className="mt-3"
																															style={{
																																fontSize: "1.4rem",
																																// paddingTop: "3.5%",
																																// paddingBottom: "1.5%",
																															}}
																														>
																															Account Details
																														</Typography>
																														<hr />
																														<Row >
																															<Col md={6} class="detail-info row">
																																<Row>

																																	<Col md={6}>First Six</Col>
																																	<Col md={6}>
																																		{!row.firstSix || row.firstSix == ""
																																			? "-"
																																			: row.firstSix}
																																	</Col>
																																</Row>
																															</Col>

																															<Col md={6} class="detail-info row">
																																<Row>

																																	<Col md={6}>Last Four</Col>
																																	<Col md={6}>
																																		{!row.lastFour || row.lastFour == ""
																																			? "-"
																																			: row.lastFour}
																																	</Col>
																																</Row>
																															</Col>
																														</Row>
																														<hr />
																														<Row >
																															<Col md={6} class="detail-info row">
																																<Row>

																																	<Col md={6}>Card Holder Name</Col>
																																	<Col md={6}>
																																		{!row.cardHolderName || row.cardHolderName == ""
																																			? "-"
																																			: row.cardHolderName}
																																	</Col>
																																</Row>
																															</Col>
																					
																														</Row>
																														<hr />
																															</Col>
																												</Row>} */}
																											<Typography
																												variant="h6"
																												component="div"
																												className="mt-3"
																												style={{
																													fontSize: "1.4rem",
																													// paddingTop: "3.5%",
																													// paddingBottom: "1.5%",
																												}}
																											>
																												Transaction History
																											</Typography>
																											<hr />

																											<div className="ViewTranHistory">
																												<TableContainer component={Paper} >
																													<Table
																														className={classes.table}
																														aria-label="a dense table"
																														style={{ whiteSpace: "nowrap" }}
																													>
																														<TableHead>
																															<TableRow className="">
																																<TableCell
																																	align="center"
																																	style={{ color: "black" }}
																																>
																																	Action{" "}
																																</TableCell>
																																<TableCell
																																	align="center"
																																	style={{ color: "black" }}
																																>
																																	Timestamp
																																</TableCell>
																																<TableCell
																																	align="center"
																																	style={{ color: "black" }}
																																>
																																	Transaction Type
																																</TableCell>
																																<TableCell
																																	align="center"
																																	style={{ color: "black" }}
																																>
																																	Purchase Amount
																																</TableCell>
																																<TableCell
																																	align="center"
																																	style={{ color: "black" }}
																																>
																																	Currency
																																</TableCell>
																																<TableCell
																																	align="center"
																																	style={{ color: "black" }}
																																>
																																	Remark
																																</TableCell>
																															</TableRow>
																														</TableHead>
																														<TableBody>
																															{viewTransactionDetailsResArray.transactionHistoryVOList &&
																																[]
																																	.concat(viewTransactionDetailsResArray.transactionHistoryVOList)
																																	.map((row, index) => (
																																		<TableRow key={index}>
																																			<TableCell align="center">
																																				{row.status ? row.status : "-"}
																																			</TableCell>
																																			<TableCell align="center">
																																				{row.timestamp ? row.timestamp : "-"}
																																			</TableCell>
																																			<TableCell align="center">
																																				{row.transactionType ? row.transactionType : "-"}
																																			</TableCell>
																																			<TableCell align="center">
																																				{row.amount ? row.amount : "-"}
																																			</TableCell>
																																			<TableCell align="center">
																																				{row.currency ? row.currency : "-"}
																																			</TableCell>
																																			<TableCell align="center">
																																				{row.remark ? row.remark : "-"}
																																			</TableCell>

																																		</TableRow>
																																	))
																															}
																														</TableBody>
																													</Table>
																												</TableContainer>
																											</div>



																											{/* <TableCell align="center">
																												{row.transactionId
																													? row.transactionId
																													: "-"}
																											</TableCell>
																											<TableCell align="center">
																												{row.paymentId ? row.paymentId : "-"}
																											</TableCell>
																											<TableCell align="center">
																												{row.transactionAmount
																													? row.transactionAmount
																													: "-"}
																											</TableCell>
																											<TableCell align="center">
																												{row.currency ? row.currency : "-"}
																											</TableCell>
																											<TableCell align="center">
																												{row.transactionStatus
																													? row.transactionStatus
																													: "-"}
																											</TableCell>
																											<TableCell align="center">
																												{row.timestamp ? row.timestamp : "-"}
																											</TableCell> */}
																										</TableRow>
																									))}
																						</TableBody>
																					</Table>
																				)}
																			</>
																		) : (
																			""
																		)}
																		{/* </TableContainer> */}
																	</Box>
																</Collapse>

															</TableCell>
														</TableRow>
													</>
												))}
									</TableBody>
								</Table>
								{/* <Grid item xs={12} sm={12} md={4} lg={6}>
									<CustomButton
										style={{
											padding: "8px"
										}}
										onClick={getBulkUpdateStatusReq}
									>
										Update
									</CustomButton>
								</Grid> */}

								<Grid item xs={12} sm={12} md={6} lg={6}>
									<CustomButton
										style={{
											padding: "8px",
											marginLeft: "100%"
										}}
										onClick={getBulkUpdateStatusReq}
									>
										Update
									</CustomButton>
								</Grid>
								{/* <Grid item md={6}> */}

								{/* <CustomButton
										style={{
											padding: "8px",
											marginLeft: ""
										}}
										onClick={getBulkUpdateStatusReq}
									>
										Update
									</CustomButton> */}
								{/* </Grid> */}




								{/* <TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getTransactionTypeListResArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onChangePage={handleChangePage}
									onChangeRowsPerPage={handleChangeRowsPerPage}
								/> */}
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getWayTransactionListRes.data.count}
									rowsPerPage={rowsPerPage}
									page={pageNo}
									// ActionsComponent={TablePaginationActions}
									onPageChange={handleChangePageForward}
									onRowsPerPageChange={handleChangeRowsPerPage}
									// handleChangeRowsPerPage={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}
			</Layout>
			{/* <div>
				{inquiryOpenModal &&
					<Dialog open={inquiryOpenModal} onClose={handleClose}>
						<DialogTitle>
							Inquiry Details
						</DialogTitle>
						<TableContainer component={Paper} >
							<Table className={classes.table}>
								<TableHead>
									<TableRow className="themeBackground">

										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											Payment Id{" "}
										</TableCell>
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											{" "}
											Status
										</TableCell>
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											{" "}
											Currency
										</TableCell>
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											{" "}
											Remark
										</TableCell>


									</TableRow>

								</TableHead>
								<TableBody>
									<TableRow>
										<TableCell align="center" style={{ borderBottom: "0" }}>
											{inquiryDetailsRes.data.customerMasterDetailsRequestVO &&
												inquiryDetailsRes.data.customerMasterDetailsRequestVO.paymentId
												? inquiryDetailsRes.data.customerMasterDetailsRequestVO &&
												inquiryDetailsRes.data.customerMasterDetailsRequestVO.paymentId
												: "-"
											}
										</TableCell>
										<TableCell align="center" style={{ borderBottom: "0" }}>
											{inquiryDetailsRes.data.customerMasterDetailsRequestVO &&
												inquiryDetailsRes.data.customerMasterDetailsRequestVO.status
												? inquiryDetailsRes.data.customerMasterDetailsRequestVO &&
												inquiryDetailsRes.data.customerMasterDetailsRequestVO.status
												: "-"
											}
										</TableCell>
										<TableCell align="center" style={{ borderBottom: "0" }}>
											{inquiryDetailsRes.data.customerMasterDetailsRequestVO &&
												inquiryDetailsRes.data.customerMasterDetailsRequestVO.currency
												? inquiryDetailsRes.data.customerMasterDetailsRequestVO &&
												inquiryDetailsRes.data.customerMasterDetailsRequestVO.currency
												: "-"
											}
										</TableCell>
										<TableCell align="center" style={{ borderBottom: "0" }}>
											{inquiryDetailsRes.data.customerMasterDetailsRequestVO &&
												inquiryDetailsRes.data.customerMasterDetailsRequestVO.remark
												? inquiryDetailsRes.data.customerMasterDetailsRequestVO &&
												inquiryDetailsRes.data.customerMasterDetailsRequestVO.remark
												: "-"
											}
										</TableCell>

									</TableRow>

								</TableBody>

							</Table>

						</TableContainer>

	
						<DialogActions className="p-3">

				


							<CustomButton
								style={{
								
									color: "white"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</CustomButton>

						</DialogActions>


					</Dialog>
				}

			</div> */}

			<div>
				{inquiryOpenModal && (

					<Dialog open={inquiryOpenModal} onClose={handleClose} maxWidth="md" fullWidth>

						<DialogTitle>Inquiry Details</DialogTitle>
						<DialogTitle>Gateway Name : {" "}
							{inquiryDetailsRes.data.customerMasterDetailsRequestVO && inquiryDetailsRes.data.customerMasterDetailsRequestVO.integrationName ? inquiryDetailsRes.data.customerMasterDetailsRequestVO.integrationName : "-"}
						</DialogTitle>
						<DialogContent dividers>
							<TableContainer component={Paper} style={{ overflow: 'hidden' }}>
								<Table>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
												Payment Id
											</TableCell>
											<TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
												Amount
											</TableCell>
											<TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
												Currency
											</TableCell>
											<TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
												Order Description
											</TableCell>
											<TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
												Status
											</TableCell>

											<TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
												Remark
											</TableCell>


										</TableRow>
									</TableHead>
									<TableBody>
										<TableRow>
											<TableCell align="center" style={{ borderBottom: "0" }}>
												{inquiryDetailsRes.data.customerMasterDetailsRequestVO && inquiryDetailsRes.data.customerMasterDetailsRequestVO.paymentId ? inquiryDetailsRes.data.customerMasterDetailsRequestVO.paymentId : "-"}
											</TableCell>
											<TableCell align="center" style={{ borderBottom: "0" }}>
												{inquiryDetailsRes.data.customerMasterDetailsRequestVO && inquiryDetailsRes.data.customerMasterDetailsRequestVO.amount ? inquiryDetailsRes.data.customerMasterDetailsRequestVO.amount : "-"}
											</TableCell>
											<TableCell align="center" style={{ borderBottom: "0" }}>
												{inquiryDetailsRes.data.customerMasterDetailsRequestVO && inquiryDetailsRes.data.customerMasterDetailsRequestVO.currency ? inquiryDetailsRes.data.customerMasterDetailsRequestVO.currency : "-"}
											</TableCell>
											<TableCell align="center" style={{ borderBottom: "0" }}>
												{inquiryDetailsRes.data.customerMasterDetailsRequestVO && inquiryDetailsRes.data.customerMasterDetailsRequestVO.orderDescription ? inquiryDetailsRes.data.customerMasterDetailsRequestVO.orderDescription : "-"}
											</TableCell>
											<TableCell align="center" style={{ borderBottom: "0" }}>
												{inquiryDetailsRes.data.customerMasterDetailsRequestVO && inquiryDetailsRes.data.customerMasterDetailsRequestVO.status ? inquiryDetailsRes.data.customerMasterDetailsRequestVO.status : "-"}
											</TableCell>

											<TableCell align="center" style={{ borderBottom: "0" }}>
												{inquiryDetailsRes.data.customerMasterDetailsRequestVO && inquiryDetailsRes.data.customerMasterDetailsRequestVO.remark ? inquiryDetailsRes.data.customerMasterDetailsRequestVO.remark : "-"}
											</TableCell>


										</TableRow>
									</TableBody>
								</Table>
							</TableContainer>
						</DialogContent>
						<DialogActions className="p-3">
							<CustomButton style={{ color: "white" }} variant="contained" onClick={handleClose}>
								Close
							</CustomButton>
						</DialogActions>
					</Dialog>
				)}
			</div>

			<div>
				<Dialog open={openUpdateModal} onClose={handleClose}>
					<DialogTitle style={{ width: "400px" }}>Update Details</DialogTitle>
					<DialogContent>
						<TextField
							style={{ marginTop: "10px" }}
							// select
							size="small"
							color="primary"
							// autoFocus={true}
							type="text"
							label="Order Description"
							fullWidth={true}
							name="orgnDesc"
							value={orgnDesc || ""}
							onChange={handleChange}
							variant="standard"
							disabled
						/>

						<TextField
							autoFocus
							margin="dense"
							label="Remark"
							name="getRemark"
							type="text"
							fullWidth
							variant="standard"
							onChange={handleChange}
							value={getRemark || ""}
						/>
						<TextField
							select
							autoFocus
							margin="dense"
							label="Status"
							name="updateStatus"
							type="text"
							fullWidth
							variant="standard"
							onChange={handleChange}
							defaultValue={updateStatus || "Select Status"}
						>
							<MenuItem value="Success">Success</MenuItem>
							<MenuItem value="Failed">Failed</MenuItem>
							<MenuItem value="Pending">Pending</MenuItem>

						</TextField>
					</DialogContent>
					<DialogActions>
						<CustomButton
							style={{
								padding: "8px"
							}}
							onClick={handleClose}
						>
							Cancel
						</CustomButton>
						<CustomButton
							style={{
								padding: "8px"
							}}
							onClick={getUpdateGateWayReq}
						>
							Update
						</CustomButton>

					</DialogActions>
				</Dialog>
			</div>

			{(viewUpdateResArray.status === "success" || viewUpdateResArray.status == "Success") && (
				<div>
					<Dialog
						open={notificationRefundOpen}
						onClose={handleNoticationClose}
					>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{viewUpdateResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
			{viewUpdateResArray.status == "Failed" && (
				<div>
					<Dialog
						open={notificationRefundOpen}
						onClose={handleNoticationClose}
					>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{viewUpdateResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
			{viewUpdateResArray.status == "failed" && (
				<div>
					<Dialog
						open={notificationRefundOpen}
						onClose={handleNoticationClose}
					>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{viewUpdateResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}


			{(checkValueStatus.status === "success" || checkValueStatus.status === "Success") && (
				<div>
					<Dialog
						open={bulkStatusOpen}
						onClose={handleNoticationClose}
					>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{checkValueStatus.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
			{checkValueStatus.status === "Failed" && (
				<div>
					<Dialog
						open={bulkStatusOpen}
						onClose={handleNoticationClose}
					>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{checkValueStatus.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{checkValueStatus.status === "failed" && (
				<div>
					<Dialog
						open={bulkStatusOpen}
						onClose={handleNoticationClose}
					>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{checkValueStatus.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{checkValueStatus.status === "not found" && (
				<div>
					<Dialog
						open={bulkStatusOpen}
						onClose={handleNoticationClose}
					>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{checkValueStatus.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}



		</>
	);
};

export default Transaction;
